export default "__VITE_ASSET__BxTtobYn__"